var ProductAudio = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // src/js/audio-player.js
  var audio_player_exports = {};
  __export(audio_player_exports, {
    destroyVideoWaves: () => destroyVideoWaves,
    ensureVideoWave: () => ensureVideoWave,
    initAudioPlayers: () => initAudioPlayers,
    pauseAudioPlayersIn: () => pauseAudioPlayersIn,
    syncVideoWaves: () => syncVideoWaves,
    tickVideoWaves: () => tickVideoWaves
  });

  // node_modules/wavesurfer.js/dist/wavesurfer.esm.js
  function t(t2, e2, i2, n2) {
    return new (i2 || (i2 = Promise))((function(s2, r2) {
      function o2(t3) {
        try {
          l2(n2.next(t3));
        } catch (t4) {
          r2(t4);
        }
      }
      function a2(t3) {
        try {
          l2(n2.throw(t3));
        } catch (t4) {
          r2(t4);
        }
      }
      function l2(t3) {
        var e3;
        t3.done ? s2(t3.value) : (e3 = t3.value, e3 instanceof i2 ? e3 : new i2((function(t4) {
          t4(e3);
        }))).then(o2, a2);
      }
      l2((n2 = n2.apply(t2, e2 || [])).next());
    }));
  }
  var e = class {
    constructor() {
      this.listeners = {};
    }
    on(t2, e2, i2) {
      if (this.listeners[t2] || (this.listeners[t2] = /* @__PURE__ */ new Set()), null == i2 ? void 0 : i2.once) {
        const i3 = (...n2) => {
          this.un(t2, i3), e2(...n2);
        };
        return this.listeners[t2].add(i3), () => this.un(t2, i3);
      }
      return this.listeners[t2].add(e2), () => this.un(t2, e2);
    }
    un(t2, e2) {
      var i2;
      null === (i2 = this.listeners[t2]) || void 0 === i2 || i2.delete(e2);
    }
    once(t2, e2) {
      return this.on(t2, e2, { once: true });
    }
    unAll() {
      this.listeners = {};
    }
    emit(t2, ...e2) {
      this.listeners[t2] && this.listeners[t2].forEach(((t3) => t3(...e2)));
    }
  };
  var i = { decode: function(e2, i2) {
    return t(this, void 0, void 0, (function* () {
      const t2 = new AudioContext({ sampleRate: i2 });
      try {
        return yield t2.decodeAudioData(e2);
      } finally {
        "closed" !== t2.state && (yield t2.close().catch((() => {
        })));
      }
    }));
  }, createBuffer: function(t2, e2) {
    if (!t2 || 0 === t2.length) throw new Error("channelData must be a non-empty array");
    if (e2 <= 0) throw new Error("duration must be greater than 0");
    if ("number" == typeof t2[0] && (t2 = [t2]), !t2[0] || 0 === t2[0].length) throw new Error("channelData must contain non-empty channel arrays");
    !(function(t3) {
      const e3 = t3[0];
      if (e3.some(((t4) => t4 > 1 || t4 < -1))) {
        const i3 = e3.length;
        let n2 = 0;
        for (let t4 = 0; t4 < i3; t4++) {
          const i4 = Math.abs(e3[t4]);
          i4 > n2 && (n2 = i4);
        }
        for (const e4 of t3) for (let t4 = 0; t4 < i3; t4++) e4[t4] /= n2;
      }
    })(t2);
    const i2 = t2.map(((t3) => t3 instanceof Float32Array ? t3 : Float32Array.from(t3)));
    return { duration: e2, length: i2[0].length, sampleRate: i2[0].length / e2, numberOfChannels: i2.length, getChannelData: (t3) => {
      const e3 = i2[t3];
      if (!e3) throw new Error(`Channel ${t3} not found`);
      return e3;
    }, copyFromChannel: AudioBuffer.prototype.copyFromChannel, copyToChannel: AudioBuffer.prototype.copyToChannel };
  } };
  function n(t2, e2) {
    const i2 = e2.xmlns ? document.createElementNS(e2.xmlns, t2) : document.createElement(t2);
    for (const [t3, s2] of Object.entries(e2)) if ("children" === t3 && s2) for (const [t4, e3] of Object.entries(s2)) e3 instanceof Node ? i2.appendChild(e3) : "string" == typeof e3 ? i2.appendChild(document.createTextNode(e3)) : i2.appendChild(n(t4, e3));
    else "style" === t3 ? Object.assign(i2.style, s2) : "textContent" === t3 ? i2.textContent = s2 : i2.setAttribute(t3, s2.toString());
    return i2;
  }
  function s(t2, e2, i2) {
    const s2 = n(t2, e2 || {});
    return null == i2 || i2.appendChild(s2), s2;
  }
  function r(t2) {
    return t2 instanceof HTMLElement || "object" == typeof t2 && null !== t2 && t2.nodeType === Node.ELEMENT_NODE && "object" == typeof t2.style;
  }
  var o = Object.freeze({ __proto__: null, createElement: s, default: s, isHTMLElement: r });
  var a = { fetchBlob: function(e2, i2, n2) {
    return t(this, void 0, void 0, (function* () {
      var s2;
      const r2 = yield fetch(e2, n2);
      if (r2.status >= 400) throw new Error(`Failed to fetch ${e2}: ${r2.status} (${r2.statusText})`);
      return (function(e3, i3, n3) {
        t(this, void 0, void 0, (function* () {
          var t2;
          if (!e3.body || !e3.headers) return;
          const s3 = e3.body.getReader(), r3 = Number(e3.headers.get("Content-Length")) || 0;
          let o2 = 0;
          const a2 = () => {
            s3.cancel();
          };
          if (n3) {
            if (n3.aborted) return void s3.cancel();
            n3.addEventListener("abort", a2, { once: true });
          }
          try {
            for (; ; ) {
              const e4 = yield s3.read();
              if (e4.done) break;
              if (o2 += (null === (t2 = e4.value) || void 0 === t2 ? void 0 : t2.length) || 0, r3 > 0) {
                const t3 = Math.round(o2 / r3 * 100);
                i3(t3);
              }
            }
          } catch (t3) {
            if (t3 instanceof DOMException && "AbortError" === t3.name) return;
            console.warn("Progress tracking error:", t3);
          } finally {
            n3 && n3.removeEventListener("abort", a2);
          }
        }));
      })(r2.clone(), i2, null !== (s2 = null == n2 ? void 0 : n2.signal) && void 0 !== s2 ? s2 : void 0), r2.blob();
    }));
  } };
  function l(t2) {
    let e2 = t2;
    const i2 = /* @__PURE__ */ new Set();
    return { get value() {
      return e2;
    }, set(t3) {
      Object.is(e2, t3) || (e2 = t3, i2.forEach(((t4) => t4(e2))));
    }, update(t3) {
      this.set(t3(e2));
    }, subscribe: (t3) => (i2.add(t3), () => i2.delete(t3)) };
  }
  function h(t2, e2) {
    const i2 = l(t2());
    return e2.forEach(((e3) => e3.subscribe((() => {
      const e4 = t2();
      Object.is(i2.value, e4) || i2.set(e4);
    })))), { get value() {
      return i2.value;
    }, subscribe: (t3) => i2.subscribe(t3) };
  }
  function c(t2, e2) {
    let i2;
    const n2 = () => {
      i2 && (i2(), i2 = void 0), i2 = t2();
    }, s2 = e2.map(((t3) => t3.subscribe(n2)));
    return n2(), () => {
      i2 && (i2(), i2 = void 0), s2.forEach(((t3) => t3()));
    };
  }
  var u = class extends e {
    get isPlayingSignal() {
      return this._isPlaying;
    }
    get currentTimeSignal() {
      return this._currentTime;
    }
    get durationSignal() {
      return this._duration;
    }
    get volumeSignal() {
      return this._volume;
    }
    get mutedSignal() {
      return this._muted;
    }
    get playbackRateSignal() {
      return this._playbackRate;
    }
    get seekingSignal() {
      return this._seeking;
    }
    constructor(t2) {
      super(), this.isExternalMedia = false, this._ownBlobUrl = null, this.reactiveMediaEventCleanups = [], t2.media ? (this.media = t2.media, this.isExternalMedia = true) : this.media = document.createElement("audio"), this._isPlaying = l(false), this._currentTime = l(0), this._duration = l(0), this._volume = l(this.media.volume), this._muted = l(this.media.muted), this._playbackRate = l(this.media.playbackRate || 1), this._seeking = l(false), this.setupReactiveMediaEvents(), t2.mediaControls && (this.media.controls = true), t2.autoplay && (this.media.autoplay = true), null != t2.playbackRate && this.onMediaEvent("canplay", (() => {
        null != t2.playbackRate && (this.media.playbackRate = t2.playbackRate);
      }), { once: true });
    }
    setupReactiveMediaEvents() {
      this.reactiveMediaEventCleanups.push(this.onMediaEvent("play", (() => {
        this._isPlaying.set(true);
      }))), this.reactiveMediaEventCleanups.push(this.onMediaEvent("pause", (() => {
        this._isPlaying.set(false);
      }))), this.reactiveMediaEventCleanups.push(this.onMediaEvent("ended", (() => {
        this._isPlaying.set(false);
      }))), this.reactiveMediaEventCleanups.push(this.onMediaEvent("timeupdate", (() => {
        this._currentTime.set(this.media.currentTime);
      }))), this.reactiveMediaEventCleanups.push(this.onMediaEvent("durationchange", (() => {
        this._duration.set(this.media.duration || 0);
      }))), this.reactiveMediaEventCleanups.push(this.onMediaEvent("loadedmetadata", (() => {
        this._duration.set(this.media.duration || 0);
      }))), this.reactiveMediaEventCleanups.push(this.onMediaEvent("seeking", (() => {
        this._seeking.set(true);
      }))), this.reactiveMediaEventCleanups.push(this.onMediaEvent("seeked", (() => {
        this._seeking.set(false);
      }))), this.reactiveMediaEventCleanups.push(this.onMediaEvent("volumechange", (() => {
        this._volume.set(this.media.volume), this._muted.set(this.media.muted);
      }))), this.reactiveMediaEventCleanups.push(this.onMediaEvent("ratechange", (() => {
        this._playbackRate.set(this.media.playbackRate);
      })));
    }
    onMediaEvent(t2, e2, i2) {
      return this.media.addEventListener(t2, e2, i2), () => this.media.removeEventListener(t2, e2, i2);
    }
    getSrc() {
      return this.media.currentSrc || this.media.src || "";
    }
    revokeSrc() {
      this._ownBlobUrl && (URL.revokeObjectURL(this._ownBlobUrl), this._ownBlobUrl = null);
    }
    canPlayType(t2) {
      return "" !== this.media.canPlayType(t2);
    }
    setSrc(t2, e2) {
      const i2 = this.getSrc();
      if (t2 && i2 === t2) return;
      this.revokeSrc();
      const n2 = e2 instanceof Blob && (this.canPlayType(e2.type) || !t2) ? URL.createObjectURL(e2) : t2;
      if (n2 !== t2 && (this._ownBlobUrl = n2), i2 && this.media.removeAttribute("src"), n2 || t2) try {
        this.media.src = n2;
      } catch (e3) {
        this.media.src = t2;
      }
    }
    destroy() {
      this.reactiveMediaEventCleanups.forEach(((t2) => t2())), this.reactiveMediaEventCleanups = [], this.revokeSrc(), this.unAll(), this.isExternalMedia || (this.media.pause(), this.media.removeAttribute("src"), this.media.load(), this.media.remove());
    }
    setMediaElement(t2) {
      this.reactiveMediaEventCleanups.forEach(((t3) => t3())), this.reactiveMediaEventCleanups = [], this.media = t2, this.setupReactiveMediaEvents();
    }
    play() {
      return t(this, void 0, void 0, (function* () {
        try {
          return yield this.media.play();
        } catch (t2) {
          if (t2 instanceof DOMException && "AbortError" === t2.name) return;
          throw t2;
        }
      }));
    }
    pause() {
      this.media.pause();
    }
    isPlaying() {
      return !this.media.paused && !this.media.ended;
    }
    setTime(t2) {
      this.media.currentTime = Math.max(0, Math.min(t2, this.getDuration()));
    }
    getDuration() {
      return this.media.duration;
    }
    getCurrentTime() {
      return this.media.currentTime;
    }
    getVolume() {
      return this.media.volume;
    }
    setVolume(t2) {
      this.media.volume = t2;
    }
    getMuted() {
      return this.media.muted;
    }
    setMuted(t2) {
      this.media.muted = t2;
    }
    getPlaybackRate() {
      return this.media.playbackRate;
    }
    isSeeking() {
      return this.media.seeking;
    }
    setPlaybackRate(t2, e2) {
      null != e2 && (this.media.preservesPitch = e2), this.media.playbackRate = t2;
    }
    getMediaElement() {
      return this.media;
    }
    setSinkId(t2) {
      return this.media.setSinkId(t2);
    }
  };
  function d({ maxTop: t2, maxBottom: e2, halfHeight: i2, vScale: n2, barMinHeight: s2 = 0, barAlign: r2 }) {
    let o2 = Math.round(t2 * i2 * n2);
    let a2 = o2 + Math.round(e2 * i2 * n2) || 1;
    return a2 < s2 && (a2 = s2, r2 || (o2 = a2 / 2)), { topHeight: o2, totalHeight: a2 };
  }
  function p({ barAlign: t2, halfHeight: e2, topHeight: i2, totalHeight: n2, canvasHeight: s2 }) {
    return "top" === t2 ? 0 : "bottom" === t2 ? s2 - n2 : e2 - i2;
  }
  function m(t2, e2, i2) {
    const n2 = e2 - t2.left, s2 = i2 - t2.top;
    return [n2 / t2.width, s2 / t2.height];
  }
  function g(t2) {
    return Boolean(t2.barWidth || t2.barGap || t2.barAlign);
  }
  function f(t2, e2) {
    if (!g(e2)) return t2;
    const i2 = e2.barWidth || 0.5, n2 = i2 + (e2.barGap || i2 / 2);
    return 0 === n2 ? t2 : Math.floor(t2 / n2) * n2;
  }
  function v({ scrollLeft: t2, totalWidth: e2, numCanvases: i2 }) {
    if (0 === e2) return [0];
    const n2 = t2 / e2, s2 = Math.floor(n2 * i2);
    return [s2 - 1, s2, s2 + 1];
  }
  function b(t2) {
    const e2 = t2._cleanup;
    "function" == typeof e2 && e2();
  }
  function y(t2) {
    const e2 = l({ scrollLeft: t2.scrollLeft, scrollWidth: t2.scrollWidth, clientWidth: t2.clientWidth }), i2 = h((() => (function(t3) {
      const { scrollLeft: e3, scrollWidth: i3, clientWidth: n3 } = t3;
      if (0 === i3) return { startX: 0, endX: 1 };
      const s3 = e3 / i3, r2 = (e3 + n3) / i3;
      return { startX: Math.max(0, Math.min(1, s3)), endX: Math.max(0, Math.min(1, r2)) };
    })(e2.value)), [e2]), n2 = h((() => (function(t3) {
      return { left: t3.scrollLeft, right: t3.scrollLeft + t3.clientWidth };
    })(e2.value)), [e2]), s2 = () => {
      e2.set({ scrollLeft: t2.scrollLeft, scrollWidth: t2.scrollWidth, clientWidth: t2.clientWidth });
    };
    t2.addEventListener("scroll", s2, { passive: true });
    return { scrollData: e2, percentages: i2, bounds: n2, cleanup: () => {
      t2.removeEventListener("scroll", s2), b(e2);
    } };
  }
  var C = class extends e {
    constructor(t2, e2) {
      super(), this.timeouts = [], this.isScrollable = false, this.audioData = null, this.resizeObserver = null, this.lastContainerWidth = 0, this.isDragging = false, this.subscriptions = [], this.unsubscribeOnScroll = [], this.dragStream = null, this.scrollStream = null, this.containerInlinePadding = 0, this.onClickWrapper = (t3) => {
        const e3 = this.wrapper.getBoundingClientRect(), [i3, n3] = m(e3, t3.clientX, t3.clientY);
        this.emit("click", i3, n3);
      }, this.onDblClickWrapper = (t3) => {
        const e3 = this.wrapper.getBoundingClientRect(), [i3, n3] = m(e3, t3.clientX, t3.clientY);
        this.emit("dblclick", i3, n3);
      }, this.subscriptions = [], this.options = t2;
      const i2 = this.parentFromOptionsContainer(t2.container);
      this.parent = i2;
      const [n2, s2] = this.initHtml();
      i2.appendChild(n2), this.container = n2, this.scrollContainer = s2.querySelector(".scroll"), this.wrapper = s2.querySelector(".wrapper"), this.canvasWrapper = s2.querySelector(".canvases"), this.progressWrapper = s2.querySelector(".progress"), this.cursor = s2.querySelector(".cursor"), this.calculateInlinePadding(), e2 && s2.appendChild(e2), this.initEvents();
    }
    parentFromOptionsContainer(t2) {
      let e2;
      if ("string" == typeof t2 ? e2 = document.querySelector(t2) : r(t2) && (e2 = t2), !e2) throw new Error("Container not found");
      return e2;
    }
    initEvents() {
      this.wrapper.addEventListener("click", this.onClickWrapper), this.wrapper.addEventListener("dblclick", this.onDblClickWrapper), true !== this.options.dragToSeek && "object" != typeof this.options.dragToSeek || this.initDrag(), this.scrollStream = y(this.scrollContainer);
      const t2 = c((() => {
        const { startX: t3, endX: e2 } = this.scrollStream.percentages.value, { left: i2, right: n2 } = this.scrollStream.bounds.value;
        this.emit("scroll", t3, e2, i2, n2);
      }), [this.scrollStream.percentages, this.scrollStream.bounds]);
      if (this.subscriptions.push(t2), "function" == typeof ResizeObserver) {
        const t3 = this.createDelay(100);
        this.resizeObserver = new ResizeObserver((() => {
          t3().then((() => this.onContainerResize())).catch((() => {
          }));
        })), this.resizeObserver.observe(this.scrollContainer);
      }
    }
    onContainerResize() {
      const t2 = this.parent.clientWidth;
      this.calculateInlinePadding(), t2 === this.lastContainerWidth && "auto" !== this.options.height || (this.lastContainerWidth = t2, this.reRender(), this.emit("resize"));
    }
    initDrag() {
      if (this.dragStream) return;
      this.dragStream = (function(t3, e2 = {}) {
        const { threshold: i2 = 3, mouseButton: n2 = 0, touchDelay: s2 = 100 } = e2, r2 = l(null), o2 = /* @__PURE__ */ new Map(), a2 = matchMedia("(pointer: coarse)").matches;
        let h2 = () => {
        };
        const c2 = (e3) => {
          if (e3.button !== n2) return;
          if (o2.has(e3.pointerId)) return;
          if (o2.set(e3.pointerId, e3), o2.size > 1) return;
          const l2 = e3.pointerId;
          let c3 = e3.clientX, u2 = e3.clientY, d2 = false;
          const p2 = Date.now(), m2 = t3.getBoundingClientRect(), { left: g2, top: f2 } = m2, v2 = (t4) => {
            if (t4.pointerId !== l2) return;
            if (t4.defaultPrevented || o2.size > 1) return;
            if (a2 && Date.now() - p2 < s2) return;
            const e4 = t4.clientX, n3 = t4.clientY, h3 = e4 - c3, m3 = n3 - u2;
            (d2 || Math.abs(h3) > i2 || Math.abs(m3) > i2) && (t4.preventDefault(), t4.stopPropagation(), d2 || (r2.set({ type: "start", x: c3 - g2, y: u2 - f2 }), d2 = true), r2.set({ type: "move", x: e4 - g2, y: n3 - f2, deltaX: h3, deltaY: m3 }), c3 = e4, u2 = n3);
          }, b2 = (t4) => {
            if (o2.delete(t4.pointerId)) {
              if (t4.pointerId === l2 && d2) {
                const e4 = t4.clientX, i3 = t4.clientY;
                r2.set({ type: "end", x: e4 - g2, y: i3 - f2 });
              }
              0 === o2.size && h2();
            }
          }, y2 = (t4) => {
            t4.relatedTarget && t4.relatedTarget !== document.documentElement || b2(t4);
          }, C2 = (t4) => {
            d2 && (t4.stopPropagation(), t4.preventDefault());
          }, S2 = (t4) => {
            t4.defaultPrevented || o2.size > 1 || d2 && t4.preventDefault();
          };
          document.addEventListener("pointermove", v2), document.addEventListener("pointerup", b2), document.addEventListener("pointerout", y2), document.addEventListener("pointercancel", y2), document.addEventListener("touchmove", S2, { passive: false }), document.addEventListener("click", C2, { capture: true }), h2 = () => {
            document.removeEventListener("pointermove", v2), document.removeEventListener("pointerup", b2), document.removeEventListener("pointerout", y2), document.removeEventListener("pointercancel", y2), document.removeEventListener("touchmove", S2), setTimeout((() => {
              document.removeEventListener("click", C2, { capture: true });
            }), 10);
          };
        };
        return t3.addEventListener("pointerdown", c2), { signal: r2, cleanup: () => {
          h2(), t3.removeEventListener("pointerdown", c2), o2.clear(), b(r2);
        } };
      })(this.wrapper);
      const t2 = c((() => {
        const t3 = this.dragStream.signal.value;
        if (!t3) return;
        const e2 = this.wrapper.getBoundingClientRect().width, i2 = (n2 = t3.x / e2) < 0 ? 0 : n2 > 1 ? 1 : n2;
        var n2;
        "start" === t3.type ? (this.isDragging = true, this.emit("dragstart", i2)) : "move" === t3.type ? this.emit("drag", i2) : "end" === t3.type && (this.isDragging = false, this.emit("dragend", i2));
      }), [this.dragStream.signal]);
      this.subscriptions.push(t2);
    }
    calculateInlinePadding() {
      const { paddingLeft: t2, paddingRight: e2 } = getComputedStyle(this.scrollContainer), i2 = parseFloat(t2) + parseFloat(e2);
      this.containerInlinePadding = Number.isNaN(i2) ? 0 : i2;
    }
    initHtml() {
      const t2 = document.createElement("div"), e2 = t2.attachShadow({ mode: "open" }), i2 = this.options.cspNonce && "string" == typeof this.options.cspNonce ? this.options.cspNonce.replace(/"/g, "") : "";
      return e2.innerHTML = `
      <style${i2 ? ` nonce="${i2}"` : ""}>
        :host {
          user-select: none;
          min-width: 1px;
        }
        :host audio {
          display: block;
          width: 100%;
        }
        :host .scroll {
          overflow-x: auto;
          overflow-y: hidden;
          width: 100%;
          position: relative;
        }
        :host .noScrollbar {
          scrollbar-color: transparent;
          scrollbar-width: none;
        }
        :host .noScrollbar::-webkit-scrollbar {
          display: none;
          -webkit-appearance: none;
        }
        :host .wrapper {
          position: relative;
          overflow: visible;
          z-index: 2;
        }
        :host .canvases {
          min-height: ${this.getHeight(this.options.height, this.options.splitChannels)}px;
          pointer-events: none;
        }
        :host .canvases > div {
          position: relative;
        }
        :host canvas {
          display: block;
          position: absolute;
          top: 0;
          image-rendering: pixelated;
        }
        :host .progress {
          pointer-events: none;
          position: absolute;
          z-index: 2;
          top: 0;
          left: 0;
          width: 0;
          height: 100%;
          overflow: hidden;
        }
        :host .progress > div {
          position: relative;
        }
        :host .cursor {
          pointer-events: none;
          position: absolute;
          z-index: 5;
          top: 0;
          left: 0;
          height: 100%;
          border-radius: 2px;
        }
      </style>

      <div class="scroll" part="scroll">
        <div class="wrapper" part="wrapper">
          <div class="canvases" part="canvases"></div>
          <div class="progress" part="progress"></div>
          <div class="cursor" part="cursor"></div>
        </div>
      </div>
    `, [t2, e2];
    }
    setOptions(t2) {
      var e2;
      if (this.options.container !== t2.container) {
        const e3 = this.parentFromOptionsContainer(t2.container);
        e3.appendChild(this.container), this.parent = e3;
      }
      true === t2.dragToSeek || "object" == typeof this.options.dragToSeek ? this.initDrag() : (null === (e2 = this.dragStream) || void 0 === e2 || e2.cleanup(), this.dragStream = null), this.options = t2, this.reRender();
    }
    getWrapper() {
      return this.wrapper;
    }
    getWidth() {
      return this.scrollContainer.clientWidth - this.containerInlinePadding;
    }
    getScroll() {
      return this.scrollContainer.scrollLeft;
    }
    setScroll(t2) {
      this.scrollContainer.scrollLeft = t2;
    }
    setScrollPercentage(t2) {
      const { scrollWidth: e2 } = this.scrollContainer, i2 = e2 * t2;
      this.setScroll(i2);
    }
    destroy() {
      var t2;
      this.wrapper.removeEventListener("click", this.onClickWrapper), this.wrapper.removeEventListener("dblclick", this.onDblClickWrapper), this.timeouts.forEach(((t3) => t3())), this.timeouts = [], this.subscriptions.forEach(((t3) => t3())), this.container.remove(), this.resizeObserver && (this.resizeObserver.disconnect(), this.resizeObserver = null), null === (t2 = this.unsubscribeOnScroll) || void 0 === t2 || t2.forEach(((t3) => t3())), this.unsubscribeOnScroll = [], this.dragStream && (this.dragStream.cleanup(), this.dragStream = null), this.scrollStream && (this.scrollStream.cleanup(), this.scrollStream = null);
    }
    createDelay(t2 = 10) {
      let e2, i2;
      const n2 = () => {
        e2 && (clearTimeout(e2), e2 = void 0), i2 && (i2(), i2 = void 0);
      };
      return this.timeouts.push(n2), () => new Promise(((s2, r2) => {
        n2(), i2 = r2, e2 = setTimeout((() => {
          e2 = void 0, i2 = void 0, s2();
        }), t2);
      }));
    }
    getHeight(t2, e2) {
      var i2;
      const n2 = (null === (i2 = this.audioData) || void 0 === i2 ? void 0 : i2.numberOfChannels) || 1;
      return (function({ optionsHeight: t3, optionsSplitChannels: e3, parentHeight: i3, numberOfChannels: n3, defaultHeight: s2 = 128 }) {
        if (null == t3) return s2;
        const r2 = Number(t3);
        if (!isNaN(r2)) return r2;
        if ("auto" === t3) {
          const t4 = i3 || s2;
          return (null == e3 ? void 0 : e3.every(((t5) => !t5.overlay))) ? t4 / n3 : t4;
        }
        return s2;
      })({ optionsHeight: t2, optionsSplitChannels: e2, parentHeight: this.parent.clientHeight, numberOfChannels: n2, defaultHeight: 128 });
    }
    convertColorValues(t2, e2) {
      return (function(t3, e3, i2) {
        if (!Array.isArray(t3)) return t3 || "";
        if (0 === t3.length) return "#999";
        if (t3.length < 2) return t3[0] || "";
        const n2 = document.createElement("canvas"), s2 = n2.getContext("2d");
        if (!s2) return t3[0] || "";
        const r2 = i2 || n2.height * e3, o2 = s2.createLinearGradient(0, 0, 0, r2), a2 = 1 / (t3.length - 1);
        return t3.forEach(((t4, e4) => {
          o2.addColorStop(e4 * a2, t4);
        })), o2;
      })(t2, this.getPixelRatio(), null == e2 ? void 0 : e2.canvas.height);
    }
    getPixelRatio() {
      return t2 = window.devicePixelRatio, Math.max(1, t2 || 1);
      var t2;
    }
    renderBarWaveform(t2, e2, i2, n2) {
      const { width: s2, height: r2 } = i2.canvas, { halfHeight: o2, barWidth: a2, barRadius: l2, barIndexScale: h2, barSpacing: c2, barMinHeight: u2 } = (function({ width: t3, height: e3, length: i3, options: n3, pixelRatio: s3 }) {
        const r3 = e3 / 2, o3 = n3.barWidth ? n3.barWidth * s3 : 1, a3 = n3.barGap ? n3.barGap * s3 : n3.barWidth ? o3 / 2 : 0, l3 = o3 + a3 || 1;
        return { halfHeight: r3, barWidth: o3, barGap: a3, barRadius: n3.barRadius || 0, barMinHeight: n3.barMinHeight ? n3.barMinHeight * s3 : 0, barIndexScale: i3 > 0 ? t3 / l3 / i3 : 0, barSpacing: l3 };
      })({ width: s2, height: r2, length: (t2[0] || []).length, options: e2, pixelRatio: this.getPixelRatio() }), m2 = (function({ channelData: t3, barIndexScale: e3, barSpacing: i3, barWidth: n3, halfHeight: s3, vScale: r3, canvasHeight: o3, barAlign: a3, barMinHeight: l3 }) {
        const h3 = t3[0] || [], c3 = t3[1] || h3, u3 = h3.length, m3 = [];
        let g2 = 0, f2 = 0, v2 = 0;
        for (let t4 = 0; t4 <= u3; t4++) {
          const u4 = Math.round(t4 * e3);
          if (u4 > g2) {
            const { topHeight: t5, totalHeight: e4 } = d({ maxTop: f2, maxBottom: v2, halfHeight: s3, vScale: r3, barMinHeight: l3, barAlign: a3 }), h4 = p({ barAlign: a3, halfHeight: s3, topHeight: t5, totalHeight: e4, canvasHeight: o3 });
            m3.push({ x: g2 * i3, y: h4, width: n3, height: e4 }), g2 = u4, f2 = 0, v2 = 0;
          }
          const b2 = Math.abs(h3[t4] || 0), y2 = Math.abs(c3[t4] || 0);
          b2 > f2 && (f2 = b2), y2 > v2 && (v2 = y2);
        }
        return m3;
      })({ channelData: t2, barIndexScale: h2, barSpacing: c2, barWidth: a2, halfHeight: o2, vScale: n2, canvasHeight: r2, barAlign: e2.barAlign, barMinHeight: u2 });
      i2.beginPath();
      for (const t3 of m2) l2 && "roundRect" in i2 ? i2.roundRect(t3.x, t3.y, t3.width, t3.height, l2) : i2.rect(t3.x, t3.y, t3.width, t3.height);
      i2.fill(), i2.closePath();
    }
    renderLineWaveform(t2, e2, i2, n2) {
      const { width: s2, height: r2 } = i2.canvas, o2 = (function({ channelData: t3, width: e3, height: i3, vScale: n3 }) {
        const s3 = i3 / 2, r3 = t3[0] || [];
        return [r3, t3[1] || r3].map(((t4, i4) => {
          const r4 = t4.length, o3 = r4 ? e3 / r4 : 0, a2 = s3, l2 = 0 === i4 ? -1 : 1, h2 = [{ x: 0, y: a2 }];
          let c2 = 0, u2 = 0;
          for (let e4 = 0; e4 <= r4; e4++) {
            const i5 = Math.round(e4 * o3);
            if (i5 > c2) {
              const t5 = a2 + (Math.round(u2 * s3 * n3) || 1) * l2;
              h2.push({ x: c2, y: t5 }), c2 = i5, u2 = 0;
            }
            const r5 = Math.abs(t4[e4] || 0);
            r5 > u2 && (u2 = r5);
          }
          return h2.push({ x: c2, y: a2 }), h2;
        }));
      })({ channelData: t2, width: s2, height: r2, vScale: n2 });
      i2.beginPath();
      for (const t3 of o2) if (t3.length) {
        i2.moveTo(t3[0].x, t3[0].y);
        for (let e3 = 1; e3 < t3.length; e3++) {
          const n3 = t3[e3];
          i2.lineTo(n3.x, n3.y);
        }
      }
      i2.fill(), i2.closePath();
    }
    renderWaveform(t2, e2, i2) {
      if (i2.fillStyle = this.convertColorValues(e2.waveColor, i2), e2.renderFunction) return void e2.renderFunction(t2, i2);
      const n2 = (function({ channelData: t3, barHeight: e3, normalize: i3, maxPeak: n3 }) {
        var s2;
        const r2 = e3 || 1;
        if (!i3) return r2;
        const o2 = t3[0];
        if (!o2 || 0 === o2.length) return r2;
        let a2 = null != n3 ? n3 : 0;
        if (!n3) for (let t4 = 0; t4 < o2.length; t4++) {
          const e4 = null !== (s2 = o2[t4]) && void 0 !== s2 ? s2 : 0, i4 = Math.abs(e4);
          i4 > a2 && (a2 = i4);
        }
        return a2 ? r2 / a2 : r2;
      })({ channelData: t2, barHeight: e2.barHeight, normalize: e2.normalize, maxPeak: e2.maxPeak });
      g(e2) ? this.renderBarWaveform(t2, e2, i2, n2) : this.renderLineWaveform(t2, e2, i2, n2);
    }
    renderSingleCanvas(t2, e2, i2, n2, s2, r2, o2) {
      const a2 = this.getPixelRatio(), l2 = document.createElement("canvas");
      l2.width = Math.round(i2 * a2), l2.height = Math.round(n2 * a2), l2.style.width = `${i2}px`, l2.style.height = `${n2}px`, l2.style.left = `${Math.round(s2)}px`, r2.appendChild(l2);
      const h2 = l2.getContext("2d");
      if (e2.renderFunction ? (h2.fillStyle = this.convertColorValues(e2.waveColor, h2), e2.renderFunction(t2, h2)) : this.renderWaveform(t2, e2, h2), l2.width > 0 && l2.height > 0) {
        const t3 = l2.cloneNode(), i3 = t3.getContext("2d");
        i3.drawImage(l2, 0, 0), i3.globalCompositeOperation = "source-in", i3.fillStyle = this.convertColorValues(e2.progressColor, i3), i3.fillRect(0, 0, l2.width, l2.height), o2.appendChild(t3);
      }
    }
    renderMultiCanvas(t2, e2, i2, n2, s2, r2) {
      const o2 = this.getPixelRatio(), { clientWidth: a2 } = this.scrollContainer, l2 = i2 / o2, h2 = (function({ clientWidth: t3, totalWidth: e3, options: i3 }) {
        return f(Math.min(8e3, t3, e3), i3);
      })({ clientWidth: a2, totalWidth: l2, options: e2 });
      let c2 = {};
      if (0 === h2) return;
      const u2 = (i3) => {
        if (i3 < 0 || i3 >= d2) return;
        if (c2[i3]) return;
        c2[i3] = true;
        const o3 = i3 * h2;
        let a3 = Math.min(l2 - o3, h2);
        if (a3 = f(a3, e2), a3 <= 0) return;
        const u3 = (function({ channelData: t3, offset: e3, clampedWidth: i4, totalWidth: n3 }) {
          return t3.map(((t4) => {
            const s3 = Math.floor(e3 / n3 * t4.length), r3 = Math.floor((e3 + i4) / n3 * t4.length);
            return t4.slice(s3, r3);
          }));
        })({ channelData: t2, offset: o3, clampedWidth: a3, totalWidth: l2 });
        this.renderSingleCanvas(u3, e2, a3, n2, o3, s2, r2);
      }, d2 = Math.ceil(l2 / h2);
      if (!this.isScrollable) {
        for (let t3 = 0; t3 < d2; t3++) u2(t3);
        return;
      }
      if (v({ scrollLeft: this.scrollContainer.scrollLeft, totalWidth: l2, numCanvases: d2 }).forEach(((t3) => u2(t3))), d2 > 1) {
        const t3 = this.on("scroll", (() => {
          const { scrollLeft: t4 } = this.scrollContainer;
          Object.keys(c2).length > 10 && (s2.innerHTML = "", r2.innerHTML = "", c2 = {}), v({ scrollLeft: t4, totalWidth: l2, numCanvases: d2 }).forEach(((t5) => u2(t5)));
        }));
        this.unsubscribeOnScroll.push(t3);
      }
    }
    renderChannel(t2, e2, i2, n2) {
      var { overlay: s2 } = e2, r2 = (function(t3, e3) {
        var i3 = {};
        for (var n3 in t3) Object.prototype.hasOwnProperty.call(t3, n3) && e3.indexOf(n3) < 0 && (i3[n3] = t3[n3]);
        if (null != t3 && "function" == typeof Object.getOwnPropertySymbols) {
          var s3 = 0;
          for (n3 = Object.getOwnPropertySymbols(t3); s3 < n3.length; s3++) e3.indexOf(n3[s3]) < 0 && Object.prototype.propertyIsEnumerable.call(t3, n3[s3]) && (i3[n3[s3]] = t3[n3[s3]]);
        }
        return i3;
      })(e2, ["overlay"]);
      const o2 = document.createElement("div"), a2 = this.getHeight(r2.height, r2.splitChannels);
      o2.style.height = `${a2}px`, s2 && n2 > 0 && (o2.style.marginTop = `-${a2}px`), this.canvasWrapper.style.minHeight = `${a2}px`, this.canvasWrapper.appendChild(o2);
      const l2 = o2.cloneNode();
      this.progressWrapper.appendChild(l2), this.renderMultiCanvas(t2, r2, i2, a2, o2, l2);
    }
    render(e2) {
      return t(this, void 0, void 0, (function* () {
        var t2;
        this.timeouts.forEach(((t3) => t3())), this.timeouts = [], this.unsubscribeOnScroll.forEach(((t3) => t3())), this.unsubscribeOnScroll = [], this.canvasWrapper.innerHTML = "", this.progressWrapper.innerHTML = "", null != this.options.width && (this.scrollContainer.style.width = "number" == typeof this.options.width ? `${this.options.width}px` : this.options.width);
        const i2 = this.getPixelRatio(), n2 = this.scrollContainer.clientWidth - this.containerInlinePadding, { scrollWidth: s2, isScrollable: r2, useParentWidth: o2, width: a2 } = (function({ duration: t3, minPxPerSec: e3 = 0, parentWidth: i3, fillParent: n3, pixelRatio: s3 }) {
          const r3 = Math.ceil(t3 * e3), o3 = r3 > i3, a3 = Boolean(n3 && !o3);
          return { scrollWidth: r3, isScrollable: o3, useParentWidth: a3, width: (a3 ? i3 : r3) * s3 };
        })({ duration: e2.duration, minPxPerSec: this.options.minPxPerSec || 0, parentWidth: n2, fillParent: this.options.fillParent, pixelRatio: i2 });
        if (this.isScrollable = r2, this.wrapper.style.width = o2 ? "100%" : `${s2}px`, this.scrollContainer.style.overflowX = this.isScrollable ? "auto" : "hidden", this.scrollContainer.classList.toggle("noScrollbar", !!this.options.hideScrollbar), this.cursor.style.backgroundColor = `${this.options.cursorColor || this.options.progressColor}`, this.cursor.style.width = `${this.options.cursorWidth}px`, this.audioData = e2, this.emit("render"), this.options.splitChannels) for (let i3 = 0; i3 < e2.numberOfChannels; i3++) {
          const n3 = Object.assign(Object.assign({}, this.options), null === (t2 = this.options.splitChannels) || void 0 === t2 ? void 0 : t2[i3]);
          this.renderChannel([e2.getChannelData(i3)], n3, a2, i3);
        }
        else {
          const t3 = [e2.getChannelData(0)];
          e2.numberOfChannels > 1 && t3.push(e2.getChannelData(1)), this.renderChannel(t3, this.options, a2, 0);
        }
        Promise.resolve().then((() => this.emit("rendered")));
      }));
    }
    reRender() {
      if (this.unsubscribeOnScroll.forEach(((t3) => t3())), this.unsubscribeOnScroll = [], !this.audioData) return;
      const { scrollWidth: t2 } = this.scrollContainer, { right: e2 } = this.progressWrapper.getBoundingClientRect();
      if (this.render(this.audioData), !this.isScrollable && this.scrollContainer.scrollLeft) this.scrollContainer.scrollLeft = 0;
      else if (this.isScrollable && t2 !== this.scrollContainer.scrollWidth) {
        const { right: t3 } = this.progressWrapper.getBoundingClientRect(), i2 = (function(t4) {
          const e3 = 2 * t4;
          return (e3 < 0 ? Math.floor(e3) : Math.ceil(e3)) / 2;
        })(t3 - e2);
        this.scrollContainer.scrollLeft += i2;
      }
    }
    zoom(t2) {
      this.options.minPxPerSec = t2, this.reRender();
    }
    scrollIntoView(t2, e2 = false) {
      var i2;
      const { scrollLeft: n2, scrollWidth: s2, clientWidth: r2 } = this.scrollContainer, o2 = t2 * s2, a2 = n2, l2 = n2 + r2, h2 = r2 / 2;
      if (this.isDragging) {
        const t3 = 30;
        o2 + t3 > l2 ? this.scrollContainer.scrollLeft += t3 : o2 - t3 < a2 && (this.scrollContainer.scrollLeft -= t3);
      } else {
        (o2 < a2 || o2 > l2) && (this.scrollContainer.scrollLeft = o2 - (this.options.autoCenter ? h2 : 0));
        const t3 = o2 - n2 - h2;
        if (e2 && this.options.autoCenter && t3 > 0) {
          const e3 = null === (i2 = this.audioData) || void 0 === i2 ? void 0 : i2.duration;
          if (void 0 === e3 || e3 <= 0) return void (this.scrollContainer.scrollLeft += t3);
          const n3 = s2 / e3;
          this.scrollContainer.scrollLeft += n3 <= 600 ? Math.min(t3, 10) : t3;
        }
      }
    }
    renderProgress(t2, e2) {
      if (isNaN(t2)) return;
      const i2 = 100 * t2;
      this.canvasWrapper.style.clipPath = `polygon(${i2}% 0%, 100% 0%, 100% 100%, ${i2}% 100%)`, this.progressWrapper.style.width = `${i2}%`, this.cursor.style.left = `${i2}%`, this.cursor.style.transform = this.options.cursorWidth ? `translateX(-${t2 * this.options.cursorWidth}px)` : "", this.isScrollable && this.options.autoScroll && this.audioData && this.audioData.duration > 0 && this.scrollIntoView(t2, e2);
    }
    exportImage(e2, i2, n2) {
      return t(this, void 0, void 0, (function* () {
        const t2 = this.canvasWrapper.querySelectorAll("canvas");
        if (!t2.length) throw new Error("No waveform data");
        if ("dataURL" === n2) {
          const n3 = Array.from(t2).map(((t3) => t3.toDataURL(e2, i2)));
          return Promise.resolve(n3);
        }
        return Promise.all(Array.from(t2).map(((t3) => new Promise(((n3, s2) => {
          t3.toBlob(((t4) => {
            t4 ? n3(t4) : s2(new Error("Could not export image"));
          }), e2, i2);
        })))));
      }));
    }
  };
  var S = class extends e {
    constructor() {
      super(...arguments), this.animationFrameId = null, this.isRunning = false;
    }
    start() {
      if (this.isRunning) return;
      this.isRunning = true;
      const t2 = () => {
        this.isRunning && (this.emit("tick"), this.animationFrameId = requestAnimationFrame(t2));
      };
      t2();
    }
    stop() {
      this.isRunning = false, null !== this.animationFrameId && (cancelAnimationFrame(this.animationFrameId), this.animationFrameId = null);
    }
    destroy() {
      this.stop(), this.unAll();
    }
  };
  var E = class extends e {
    constructor(t2) {
      super(), this.bufferNode = null, this.playStartTime = 0, this.playbackPosition = 0, this._muted = false, this._playbackRate = 1, this._duration = void 0, this.buffer = null, this.currentSrc = "", this.paused = true, this.crossOrigin = null, this.seeking = false, this.autoplay = false, this.addEventListener = this.on, this.removeEventListener = this.un, this._destroyed = false, (function() {
        const t3 = globalThis.navigator;
        if (null == t3 ? void 0 : t3.audioSession) try {
          t3.audioSession.type = "playback";
        } catch (t4) {
          console.warn("Setting navigator.audioSession.type failed:", t4);
        }
      })(), this.audioContext = t2 || new AudioContext(), this.gainNode = this.audioContext.createGain(), this.gainNode.connect(this.audioContext.destination);
    }
    load() {
      return t(this, void 0, void 0, (function* () {
      }));
    }
    remove() {
      this.destroy();
    }
    destroy() {
      if (!this._destroyed) {
        if (this._destroyed = true, this.currentSrc = "", this.bufferNode) {
          this.bufferNode.onended = null;
          try {
            this.bufferNode.stop();
          } catch (t2) {
          }
          this.bufferNode.disconnect(), this.bufferNode = null;
        }
        this.gainNode.disconnect(), "function" == typeof this.audioContext.close && Promise.resolve(this.audioContext.close.call(this.audioContext)).catch((() => {
        })), this.buffer = null, this.unAll();
      }
    }
    get src() {
      return this.currentSrc;
    }
    set src(t2) {
      if (this.currentSrc = t2, this._duration = void 0, !t2) return this.buffer = null, void this.emit("emptied");
      fetch(t2).then(((e2) => {
        if (e2.status >= 400) throw new Error(`Failed to fetch ${t2}: ${e2.status} (${e2.statusText})`);
        return e2.arrayBuffer();
      })).then(((e2) => this.currentSrc !== t2 ? null : this.audioContext.decodeAudioData(e2))).then(((e2) => {
        this.currentSrc === t2 && (this.buffer = e2, this.emit("loadedmetadata"), this.emit("canplay"), this.autoplay && this.play());
      })).catch(((t3) => {
        console.error("WebAudioPlayer load error:", t3);
      }));
    }
    _play() {
      if (!this.paused) return;
      this.paused = false, this.bufferNode && (this.bufferNode.onended = null, this.bufferNode.disconnect()), this.bufferNode = this.audioContext.createBufferSource(), this.buffer && (this.bufferNode.buffer = this.buffer), this.bufferNode.playbackRate.value = this._playbackRate, this.bufferNode.connect(this.gainNode);
      let t2 = this.playbackPosition;
      (t2 >= this.duration || t2 < 0) && (t2 = 0, this.playbackPosition = 0), this.bufferNode.start(this.audioContext.currentTime, t2), this.playStartTime = this.audioContext.currentTime, this.bufferNode.onended = () => {
        !this.paused && this.duration - this.currentTime < 0.01 && (this.pause(), this.emit("ended"));
      };
    }
    _pause() {
      if (this.paused = true, this.bufferNode) {
        this.bufferNode.onended = null;
        try {
          this.bufferNode.stop();
        } catch (t2) {
        }
      }
      this.playbackPosition += (this.audioContext.currentTime - this.playStartTime) * this._playbackRate;
    }
    play() {
      return t(this, void 0, void 0, (function* () {
        this.paused && (this._play(), this.emit("play"));
      }));
    }
    pause() {
      this.paused || (this._pause(), this.emit("pause"));
    }
    stopAt(t2) {
      const e2 = (t2 - this.currentTime) / this._playbackRate, i2 = this.bufferNode;
      null == i2 || i2.stop(this.audioContext.currentTime + e2), null == i2 || i2.addEventListener("ended", (() => {
        i2 === this.bufferNode && (this.bufferNode = null, this.pause(), this.playbackPosition = Math.min(t2, this.duration), this.emit("timeupdate"));
      }), { once: true });
    }
    setSinkId(e2) {
      return t(this, void 0, void 0, (function* () {
        return this.audioContext.setSinkId(e2);
      }));
    }
    get playbackRate() {
      return this._playbackRate;
    }
    set playbackRate(t2) {
      const e2 = !this.paused;
      e2 && this._pause(), this._playbackRate = t2, e2 && this._play(), this.bufferNode && (this.bufferNode.playbackRate.value = t2);
    }
    get currentTime() {
      return this.paused ? this.playbackPosition : this.playbackPosition + (this.audioContext.currentTime - this.playStartTime) * this._playbackRate;
    }
    set currentTime(t2) {
      const e2 = !this.paused;
      e2 && this._pause(), this.playbackPosition = t2, e2 && this._play(), this.emit("seeking"), this.emit("timeupdate");
    }
    get duration() {
      var t2, e2;
      return null !== (t2 = this._duration) && void 0 !== t2 ? t2 : (null === (e2 = this.buffer) || void 0 === e2 ? void 0 : e2.duration) || 0;
    }
    set duration(t2) {
      this._duration = t2;
    }
    get volume() {
      return this.gainNode.gain.value;
    }
    set volume(t2) {
      this.gainNode.gain.value = t2, this.emit("volumechange");
    }
    get muted() {
      return this._muted;
    }
    set muted(t2) {
      this._muted !== t2 && (this._muted = t2, this._muted ? this.gainNode.disconnect() : this.gainNode.connect(this.audioContext.destination));
    }
    canPlayType(t2) {
      return /^(audio|video)\//.test(t2);
    }
    getGainNode() {
      return this.gainNode;
    }
    getChannelData() {
      const t2 = [];
      if (!this.buffer) return t2;
      const e2 = this.buffer.numberOfChannels;
      for (let i2 = 0; i2 < e2; i2++) t2.push(this.buffer.getChannelData(i2));
      return t2;
    }
    removeAttribute(t2) {
      switch (t2) {
        case "src":
          this.src = "";
          break;
        case "playbackRate":
          this.playbackRate = 0;
          break;
        case "currentTime":
          this.currentTime = 0;
          break;
        case "duration":
          this.duration = 0;
          break;
        case "volume":
          this.volume = 0;
          break;
        case "muted":
          this.muted = false;
      }
    }
  };
  var P = { waveColor: "#999", progressColor: "#555", cursorWidth: 1, minPxPerSec: 0, fillParent: true, interact: true, dragToSeek: false, autoScroll: true, autoCenter: true, sampleRate: 8e3 };
  var w = class _w extends u {
    static create(t2) {
      return new _w(t2);
    }
    getState() {
      return this.wavesurferState;
    }
    getRenderer() {
      return this.renderer;
    }
    constructor(t2) {
      const e2 = t2.media || ("WebAudio" === t2.backend ? new E() : void 0);
      super({ media: e2, mediaControls: t2.mediaControls, autoplay: t2.autoplay, playbackRate: t2.audioRate }), this.plugins = [], this.decodedData = null, this.stopAtPosition = null, this.subscriptions = [], this.mediaSubscriptions = [], this.abortController = null, this._isDestroyed = false, this._loadVersion = 0, this.reactiveCleanups = [], this.options = Object.assign({}, P, t2);
      const { state: i2, actions: n2 } = (function(t3) {
        var e3, i3, n3, s3, r3, o2;
        const a2 = null !== (e3 = null == t3 ? void 0 : t3.currentTime) && void 0 !== e3 ? e3 : l(0), c2 = null !== (i3 = null == t3 ? void 0 : t3.duration) && void 0 !== i3 ? i3 : l(0), u2 = null !== (n3 = null == t3 ? void 0 : t3.isPlaying) && void 0 !== n3 ? n3 : l(false), d2 = null !== (s3 = null == t3 ? void 0 : t3.isSeeking) && void 0 !== s3 ? s3 : l(false), p2 = null !== (r3 = null == t3 ? void 0 : t3.volume) && void 0 !== r3 ? r3 : l(1), m2 = null !== (o2 = null == t3 ? void 0 : t3.playbackRate) && void 0 !== o2 ? o2 : l(1), g2 = l(null), f2 = l(null), v2 = l(""), b2 = l(0), y2 = l(0), C2 = h((() => !u2.value), [u2]), S2 = h((() => null !== g2.value), [g2]), E2 = h((() => S2.value && c2.value > 0), [S2, c2]), P2 = h((() => a2.value), [a2]), w2 = h((() => c2.value > 0 ? a2.value / c2.value : 0), [a2, c2]);
        return { state: { currentTime: a2, duration: c2, isPlaying: u2, isPaused: C2, isSeeking: d2, volume: p2, playbackRate: m2, audioBuffer: g2, peaks: f2, url: v2, zoom: b2, scrollPosition: y2, canPlay: S2, isReady: E2, progress: P2, progressPercent: w2 }, actions: { setCurrentTime: (t4) => {
          const e4 = Math.max(0, Math.min(c2.value || 1 / 0, t4));
          a2.set(e4);
        }, setDuration: (t4) => {
          c2.set(Math.max(0, t4));
        }, setPlaying: (t4) => {
          u2.set(t4);
        }, setSeeking: (t4) => {
          d2.set(t4);
        }, setVolume: (t4) => {
          const e4 = Math.max(0, Math.min(1, t4));
          p2.set(e4);
        }, setPlaybackRate: (t4) => {
          const e4 = Math.max(0.1, Math.min(16, t4));
          m2.set(e4);
        }, setAudioBuffer: (t4) => {
          g2.set(t4), t4 && c2.set(t4.duration);
        }, setPeaks: (t4) => {
          f2.set(t4);
        }, setUrl: (t4) => {
          v2.set(t4);
        }, setZoom: (t4) => {
          b2.set(Math.max(0, t4));
        }, setScrollPosition: (t4) => {
          y2.set(Math.max(0, t4));
        } } };
      })({ isPlaying: this.isPlayingSignal, currentTime: this.currentTimeSignal, duration: this.durationSignal, volume: this.volumeSignal, playbackRate: this.playbackRateSignal, isSeeking: this.seekingSignal });
      this.wavesurferState = i2, this.wavesurferActions = n2, this.timer = new S();
      const s2 = e2 ? void 0 : this.getMediaElement();
      this.renderer = new C(this.options, s2), this.initPlayerEvents(), this.initRendererEvents(), this.initTimerEvents(), this.initReactiveState(), this.initPlugins();
      const r2 = this.options.url || this.getSrc() || "";
      Promise.resolve().then((() => {
        this.emit("init");
        const { peaks: t3, duration: e3 } = this.options;
        (r2 || t3 && e3) && this.load(r2, t3, e3).catch((() => {
        }));
      }));
    }
    updateProgress(t2 = this.getCurrentTime()) {
      return this.renderer.renderProgress(t2 / this.getDuration(), this.isPlaying()), t2;
    }
    initTimerEvents() {
      this.subscriptions.push(this.timer.on("tick", (() => {
        if (!this.isSeeking()) {
          const t2 = this.updateProgress();
          if (this.emit("timeupdate", t2), this.emit("audioprocess", t2), null != this.stopAtPosition && this.isPlaying() && t2 >= this.stopAtPosition) {
            const t3 = this.stopAtPosition;
            this.pause(), this.setTime(t3);
          }
        }
      })));
    }
    initReactiveState() {
      this.reactiveCleanups.push((function(t2, e2) {
        const i2 = [];
        i2.push(c((() => {
          const i3 = t2.isPlaying.value;
          e2.emit(i3 ? "play" : "pause");
        }), [t2.isPlaying])), i2.push(c((() => {
          const i3 = t2.currentTime.value;
          e2.emit("timeupdate", i3), t2.isPlaying.value && e2.emit("audioprocess", i3);
        }), [t2.currentTime, t2.isPlaying])), i2.push(c((() => {
          t2.isSeeking.value && e2.emit("seeking", t2.currentTime.value);
        }), [t2.isSeeking, t2.currentTime]));
        let n2 = false;
        i2.push(c((() => {
          t2.isReady.value && !n2 && (n2 = true, e2.emit("ready", t2.duration.value));
        }), [t2.isReady, t2.duration])), i2.push(c((() => {
          null === t2.audioBuffer.value && (n2 = false);
        }), [t2.audioBuffer]));
        let s2 = false;
        return i2.push(c((() => {
          const i3 = t2.isPlaying.value, n3 = t2.currentTime.value, r2 = t2.duration.value, o2 = r2 > 0 && n3 >= r2;
          s2 && !i3 && o2 && e2.emit("finish"), s2 = i3 && o2;
        }), [t2.isPlaying, t2.currentTime, t2.duration])), i2.push(c((() => {
          const i3 = t2.zoom.value;
          i3 > 0 && e2.emit("zoom", i3);
        }), [t2.zoom])), () => {
          i2.forEach(((t3) => t3()));
        };
      })(this.wavesurferState, { emit: this.emit.bind(this) }));
    }
    initPlayerEvents() {
      this.isPlaying() && (this.emit("play"), this.timer.start()), this.mediaSubscriptions.push(this.onMediaEvent("timeupdate", (() => {
        const t2 = this.updateProgress();
        this.emit("timeupdate", t2);
      })), this.onMediaEvent("play", (() => {
        this.emit("play"), this.timer.start();
      })), this.onMediaEvent("pause", (() => {
        this.emit("pause"), this.timer.stop(), this.stopAtPosition = null;
      })), this.onMediaEvent("emptied", (() => {
        this.timer.stop(), this.stopAtPosition = null;
      })), this.onMediaEvent("ended", (() => {
        this.emit("timeupdate", this.getDuration()), this.emit("finish"), this.stopAtPosition = null;
      })), this.onMediaEvent("seeking", (() => {
        this.emit("seeking", this.getCurrentTime());
      })), this.onMediaEvent("error", (() => {
        var t2;
        this.emit("error", null !== (t2 = this.getMediaElement().error) && void 0 !== t2 ? t2 : new Error("Media error")), this.stopAtPosition = null;
      })));
    }
    initRendererEvents() {
      this.subscriptions.push(this.renderer.on("click", ((t2, e2) => {
        this.options.interact && (this.seekTo(t2), this.emit("interaction", t2 * this.getDuration()), this.emit("click", t2, e2));
      })), this.renderer.on("dblclick", ((t2, e2) => {
        this.emit("dblclick", t2, e2);
      })), this.renderer.on("scroll", ((t2, e2, i2, n2) => {
        const s2 = this.getDuration();
        this.emit("scroll", t2 * s2, e2 * s2, i2, n2);
      })), this.renderer.on("render", (() => {
        this.emit("redraw");
      })), this.renderer.on("rendered", (() => {
        this.emit("redrawcomplete");
      })), this.renderer.on("dragstart", ((t2) => {
        this.emit("dragstart", t2);
      })), this.renderer.on("dragend", ((t2) => {
        this.emit("dragend", t2);
      })), this.renderer.on("resize", (() => {
        this.emit("resize");
      })));
      {
        let t2;
        const e2 = this.renderer.on("drag", ((e3) => {
          var i2;
          if (!this.options.interact) return;
          this.renderer.renderProgress(e3), clearTimeout(t2);
          let n2 = 0;
          const s2 = this.options.dragToSeek;
          this.isPlaying() ? n2 = 0 : true === s2 ? n2 = 200 : s2 && "object" == typeof s2 && (n2 = null !== (i2 = s2.debounceTime) && void 0 !== i2 ? i2 : 200), t2 = setTimeout((() => {
            this.seekTo(e3);
          }), n2), this.emit("interaction", e3 * this.getDuration()), this.emit("drag", e3);
        }));
        this.subscriptions.push((() => {
          clearTimeout(t2), e2();
        }));
      }
    }
    initPlugins() {
      var t2;
      (null === (t2 = this.options.plugins) || void 0 === t2 ? void 0 : t2.length) && this.options.plugins.forEach(((t3) => {
        this.registerPlugin(t3);
      }));
    }
    unsubscribePlayerEvents() {
      this.mediaSubscriptions.forEach(((t2) => t2())), this.mediaSubscriptions = [];
    }
    setOptions(t2) {
      this.options = Object.assign({}, this.options, t2), t2.duration && !t2.peaks && (this.decodedData = i.createBuffer(this.exportPeaks(), t2.duration)), t2.peaks && t2.duration && (this.decodedData = i.createBuffer(t2.peaks, t2.duration)), this.renderer.setOptions(this.options), t2.audioRate && this.setPlaybackRate(t2.audioRate), null != t2.mediaControls && (this.getMediaElement().controls = t2.mediaControls);
    }
    registerPlugin(t2) {
      if (this.plugins.includes(t2)) return t2;
      t2._init(this), this.plugins.push(t2);
      const e2 = t2.once("destroy", (() => {
        this.plugins = this.plugins.filter(((e3) => e3 !== t2)), this.subscriptions = this.subscriptions.filter(((t3) => t3 !== e2));
      }));
      return this.subscriptions.push(e2), t2;
    }
    unregisterPlugin(t2) {
      this.plugins = this.plugins.filter(((e2) => e2 !== t2)), t2.destroy();
    }
    getWrapper() {
      return this.renderer.getWrapper();
    }
    getWidth() {
      return this.renderer.getWidth();
    }
    getScroll() {
      return this.renderer.getScroll();
    }
    setScroll(t2) {
      return this.renderer.setScroll(t2);
    }
    setScrollTime(t2) {
      const e2 = t2 / this.getDuration();
      this.renderer.setScrollPercentage(e2);
    }
    getActivePlugins() {
      return this.plugins;
    }
    loadAudio(e2, n2, s2, r2) {
      return t(this, void 0, void 0, (function* () {
        var t2;
        const o2 = ++this._loadVersion;
        if (this._isDestroyed = false, this.emit("load", e2), !this.options.media && this.isPlaying() && this.pause(), this.decodedData = null, this.stopAtPosition = null, null === (t2 = this.abortController) || void 0 === t2 || t2.abort(), this.abortController = null, !n2 && !s2) {
          const t3 = this.options.fetchParams || {};
          window.AbortController && !t3.signal && (this.abortController = new AbortController(), t3.signal = this.abortController.signal);
          const i2 = (t4) => this.emit("loading", t4);
          if (n2 = yield a.fetchBlob(e2, i2, t3), this._isDestroyed || o2 !== this._loadVersion) return;
          const s3 = this.options.blobMimeType;
          s3 && (n2 = new Blob([n2], { type: s3 }));
        }
        if (this._isDestroyed || o2 !== this._loadVersion) return;
        this.setSrc(e2, n2);
        const l2 = yield new Promise(((t3) => {
          const e3 = r2 || this.getDuration();
          e3 ? t3(e3) : this.mediaSubscriptions.push(this.onMediaEvent("loadedmetadata", (() => t3(this.getDuration())), { once: true }));
        }));
        if (!this._isDestroyed && o2 === this._loadVersion) {
          if (!e2 && !n2) {
            const t3 = this.getMediaElement();
            t3 instanceof E && (t3.duration = l2);
          }
          if (s2) this.decodedData = i.createBuffer(s2, l2 || 0);
          else if (n2) {
            const t3 = yield n2.arrayBuffer();
            if (this._isDestroyed || o2 !== this._loadVersion) return;
            this.decodedData = yield i.decode(t3, this.options.sampleRate);
          }
          this._isDestroyed || o2 !== this._loadVersion || (this.decodedData && (this.emit("decode", this.getDuration()), this.renderer.render(this.decodedData)), this.emit("ready", this.getDuration()));
        }
      }));
    }
    load(e2, i2, n2) {
      return t(this, void 0, void 0, (function* () {
        try {
          return yield this.loadAudio(e2, void 0, i2, n2);
        } catch (t2) {
          throw this.emit("error", t2), t2;
        }
      }));
    }
    loadBlob(e2, i2, n2) {
      return t(this, void 0, void 0, (function* () {
        try {
          return yield this.loadAudio("", e2, i2, n2);
        } catch (t2) {
          throw this.emit("error", t2), t2;
        }
      }));
    }
    zoom(t2) {
      if (!this.decodedData) throw new Error("No audio loaded");
      this.renderer.zoom(t2), this.emit("zoom", t2);
    }
    getDecodedData() {
      return this.decodedData;
    }
    exportPeaks({ channels: t2 = 2, maxLength: e2 = 8e3, precision: i2 = 1e4 } = {}) {
      if (!this.decodedData) throw new Error("The audio has not been decoded yet");
      const n2 = Math.min(t2, this.decodedData.numberOfChannels), s2 = [];
      for (let t3 = 0; t3 < n2; t3++) {
        const n3 = this.decodedData.getChannelData(t3), r2 = [], o2 = n3.length / e2;
        for (let t4 = 0; t4 < e2; t4++) {
          const e3 = n3.slice(Math.floor(t4 * o2), Math.ceil((t4 + 1) * o2));
          let s3 = 0;
          for (let t5 = 0; t5 < e3.length; t5++) {
            const i3 = e3[t5];
            Math.abs(i3) > Math.abs(s3) && (s3 = i3);
          }
          r2.push(Math.round(s3 * i2) / i2);
        }
        s2.push(r2);
      }
      return s2;
    }
    getDuration() {
      let t2 = super.getDuration() || 0;
      return 0 !== t2 && t2 !== 1 / 0 || !this.decodedData || (t2 = this.decodedData.duration), t2;
    }
    toggleInteraction(t2) {
      this.options.interact = t2;
    }
    setTime(t2) {
      this.stopAtPosition = null, super.setTime(t2), this.updateProgress(t2), this.emit("timeupdate", t2);
    }
    seekTo(t2) {
      const e2 = this.getDuration() * t2;
      this.setTime(e2);
    }
    play(e2, i2) {
      const n2 = Object.create(null, { play: { get: () => super.play } });
      return t(this, void 0, void 0, (function* () {
        null != e2 && this.setTime(e2);
        const t2 = yield n2.play.call(this);
        return null != i2 && (this.media instanceof E ? this.media.stopAt(i2) : this.stopAtPosition = i2), t2;
      }));
    }
    playPause() {
      return t(this, void 0, void 0, (function* () {
        return this.isPlaying() ? this.pause() : this.play();
      }));
    }
    stop() {
      this.pause(), this.setTime(0);
    }
    skip(t2) {
      this.setTime(this.getCurrentTime() + t2);
    }
    empty() {
      this.load("", [[0]], 1e-3);
    }
    setMediaElement(t2) {
      this.unsubscribePlayerEvents(), super.setMediaElement(t2), this.initPlayerEvents();
    }
    exportImage() {
      return t(this, arguments, void 0, (function* (t2 = "image/png", e2 = 1, i2 = "dataURL") {
        return this.renderer.exportImage(t2, e2, i2);
      }));
    }
    destroy() {
      var t2;
      this._isDestroyed = true, this.emit("destroy"), null === (t2 = this.abortController) || void 0 === t2 || t2.abort(), this.plugins.forEach(((t3) => t3.destroy())), this.subscriptions.forEach(((t3) => t3())), this.unsubscribePlayerEvents(), this.reactiveCleanups.forEach(((t3) => t3())), this.reactiveCleanups = [], this.timer.destroy(), this.renderer.destroy(), super.destroy();
    }
  };
  w.BasePlugin = class extends e {
    constructor(t2) {
      super(), this.subscriptions = [], this.isDestroyed = false, this.options = t2;
    }
    onInit() {
    }
    _init(t2) {
      this.isDestroyed && (this.subscriptions = [], this.isDestroyed = false), this.wavesurfer = t2, this.onInit();
    }
    destroy() {
      this.emit("destroy"), this.subscriptions.forEach(((t2) => t2())), this.subscriptions = [], this.isDestroyed = true, this.wavesurfer = void 0;
    }
  }, w.dom = o;

  // src/js/audio-player.js
  var activePlayer = null;
  var formatSeconds = (value) => {
    const safe = Math.max(0, Number.isFinite(value) ? value : 0);
    const minutes = Math.floor(safe / 60);
    const seconds = Math.floor(safe % 60);
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };
  var WAVE_BAR_WIDTH = 1;
  var WAVE_BAR_GAP = 2;
  var WAVE_BARS_PER_SECOND = 8;
  var waveSurferOptions = (container) => ({
    container,
    cursorColor: "transparent",
    cursorWidth: 0,
    barRadius: 0,
    normalize: true,
    interact: true,
    dragToSeek: true,
    fillParent: true,
    minPxPerSec: (WAVE_BAR_WIDTH + WAVE_BAR_GAP) * WAVE_BARS_PER_SECOND,
    autoScroll: true,
    autoCenter: true,
    hideScrollbar: true,
    waveColor: "#00000070",
    progressColor: "#00000070",
    height: 12,
    barWidth: WAVE_BAR_WIDTH,
    barGap: WAVE_BAR_GAP,
    barMinHeight: 0.9,
    barHeight: 1.1
  });
  var syncWaveDensity = (wavesurfer) => {
    if (!wavesurfer) return;
    const duration = wavesurfer.getDuration();
    if (!duration || duration <= 0) return;
    const minPxPerSec = (WAVE_BAR_WIDTH + WAVE_BAR_GAP) * WAVE_BARS_PER_SECOND;
    wavesurfer.zoom(minPxPerSec);
  };
  var updateWaveScrubber = (wavesurfer, scrubber, timeLabels = {}) => {
    if (!scrubber || !wavesurfer) return;
    const duration = wavesurfer.getDuration();
    const currentTime = wavesurfer.getCurrentTime();
    const progress = duration ? currentTime / duration : 0;
    const visibleWidth = wavesurfer.getWidth() || 0;
    const wrapper = wavesurfer.getWrapper();
    const totalWidth = Math.max(wrapper?.scrollWidth || 0, visibleWidth);
    const scrollLeft = wavesurfer.getScroll() || 0;
    const x = progress * totalWidth - scrollLeft;
    if (visibleWidth > 0) {
      scrubber.style.left = `${Math.min(Math.max(x, 0), visibleWidth)}px`;
    } else {
      scrubber.style.left = `${progress * 100}%`;
    }
    const { currentTimeEl, totalTimeEl } = timeLabels;
    if (currentTimeEl) {
      const remaining = duration ? Math.max(0, duration - currentTime) : 0;
      currentTimeEl.textContent = `-${formatSeconds(remaining)}`;
    }
    if (totalTimeEl) {
      totalTimeEl.textContent = formatSeconds(duration);
    }
  };
  var getMediaUrl = (media) => {
    if (!media) return "";
    return media.currentSrc || media.src || media.querySelector?.("source")?.src || "";
  };
  var ProductAudioPlayer = class {
    constructor(root) {
      this.root = root;
      this.url = root.dataset.audioUrl;
      this.playButton = root.querySelector("[data-audio-play]");
      this.muteButton = root.querySelector("[data-audio-mute]");
      this.waveContainer = root.querySelector("[data-audio-wave]");
      this.scrubber = root.querySelector("[data-audio-scrubber]");
      this.currentTimeEl = root.querySelector("[data-audio-time-current]") || root.querySelector("[data-full-teaser-time-current]");
      this.totalTimeEl = root.querySelector("[data-audio-time-total]") || root.querySelector("[data-full-teaser-time-total]");
      this.muted = false;
      if (!this.url || !this.playButton || !this.waveContainer) return;
      this.root.classList.add("is-loading");
      this.updateScrubber = this.updateScrubber.bind(this);
      this.wavesurfer = w.create({
        ...waveSurferOptions(this.waveContainer),
        url: this.url
      });
      this.playButton.addEventListener("click", () => this.toggle());
      this.muteButton?.addEventListener("click", () => this.toggleMute());
      this.wavesurfer.on("ready", () => {
        this.root.classList.remove("is-loading");
        this.wavesurfer.setMuted(this.muted);
        syncWaveDensity(this.wavesurfer);
        this.updateScrubber();
      });
      this.wavesurfer.on("play", () => this.setPlaying(true));
      this.wavesurfer.on("pause", () => this.setPlaying(false));
      this.wavesurfer.on("finish", () => this.setPlaying(false));
      this.wavesurfer.on("error", () => {
        this.root.classList.add("has-error");
        this.root.classList.remove("is-loading");
      });
      this.wavesurfer.on("timeupdate", this.updateScrubber);
      this.wavesurfer.on("interaction", this.updateScrubber);
      this.wavesurfer.on("drag", this.updateScrubber);
      this.wavesurfer.on("scroll", this.updateScrubber);
      this.wavesurfer.on("redrawcomplete", () => this.updateScrubber());
    }
    updateScrubber() {
      updateWaveScrubber(this.wavesurfer, this.scrubber, {
        currentTimeEl: this.currentTimeEl,
        totalTimeEl: this.totalTimeEl
      });
    }
    toggle() {
      if (this.wavesurfer.isPlaying()) {
        this.pause();
        return;
      }
      this.play();
    }
    play() {
      if (activePlayer && activePlayer !== this) {
        activePlayer.pause();
      }
      activePlayer = this;
      this.wavesurfer.setMuted(this.muted);
      this.wavesurfer.play();
    }
    playMuted() {
      if (activePlayer && activePlayer !== this) {
        activePlayer.pause();
      }
      activePlayer = this;
      this.setMuted(true);
      this.wavesurfer.play();
    }
    toggleMute() {
      this.setMuted(!this.muted);
    }
    setMuted(muted) {
      this.muted = Boolean(muted);
      this.wavesurfer?.setMuted(this.muted);
      this.root.classList.toggle("is-muted", this.muted);
      if (this.muteButton) {
        this.muteButton.setAttribute(
          "aria-label",
          this.muted ? "Unmute audio" : "Mute audio"
        );
      }
    }
    pause() {
      this.wavesurfer.pause();
      if (activePlayer === this) {
        activePlayer = null;
      }
    }
    setPlaying(isPlaying) {
      this.root.classList.toggle("is-playing", isPlaying);
      this.playButton.setAttribute(
        "aria-label",
        isPlaying ? "Pause audio" : "Play audio"
      );
    }
    clear() {
      if (!this.wavesurfer) return;
      this.pause();
      this.url = "";
      this.root.dataset.audioUrl = "";
      this.root.classList.remove(
        "is-loading",
        "has-error",
        "is-playing",
        "is-muted"
      );
      this.wavesurfer.empty();
      if (this.scrubber) this.scrubber.style.left = "0px";
      updateWaveScrubber(this.wavesurfer, this.scrubber, {
        currentTimeEl: this.currentTimeEl,
        totalTimeEl: this.totalTimeEl
      });
      this.playButton.setAttribute("aria-label", "Play audio");
      this.setMuted(false);
    }
    load(url, options = {}) {
      const { autoplay = false, muted = false } = options;
      if (!this.wavesurfer) return Promise.resolve(false);
      if (!url) {
        this.clear();
        return Promise.resolve(false);
      }
      const sameUrl = url === this.url;
      const afterReady = () => {
        this.root.classList.remove("is-loading");
        this.wavesurfer.setMuted(this.muted);
        syncWaveDensity(this.wavesurfer);
        this.updateScrubber();
        if (autoplay) {
          if (muted) this.playMuted();
          else this.play();
        }
      };
      if (sameUrl) {
        this.pause();
        this.wavesurfer.setTime(0);
        afterReady();
        return Promise.resolve(true);
      }
      this.pause();
      this.url = url;
      this.root.dataset.audioUrl = url;
      this.root.classList.remove("has-error");
      this.root.classList.add("is-loading");
      if (this.scrubber) this.scrubber.style.left = "0px";
      return this.wavesurfer.load(url).then(() => {
        afterReady();
        return true;
      }).catch(() => {
        this.root.classList.remove("is-loading");
        this.root.classList.add("has-error");
        return false;
      });
    }
  };
  var VideoWaveform = class {
    constructor(root) {
      this.root = root;
      this.waveContainer = root.querySelector("[data-audio-wave]");
      this.scrubber = root.querySelector("[data-audio-scrubber]");
      this.url = "";
      this.loadId = 0;
      this.wavesurfer = null;
      if (!this.waveContainer) return;
      this.updateScrubber = this.updateScrubber.bind(this);
      this.wavesurfer = w.create({
        ...waveSurferOptions(this.waveContainer),
        // seek stays on the video via full-teasers handlers
        interact: false,
        dragToSeek: false
      });
      this.wavesurfer.on("ready", () => {
        this.root.classList.remove("is-loading");
        this.wavesurfer.setMuted(true);
        this.wavesurfer.pause();
        syncWaveDensity(this.wavesurfer);
        this.updateScrubber();
      });
      this.wavesurfer.on("error", () => {
        this.root.classList.add("has-error");
        this.root.classList.remove("is-loading");
      });
      this.wavesurfer.on("redrawcomplete", this.updateScrubber);
      this.wavesurfer.on("scroll", this.updateScrubber);
    }
    updateScrubber() {
      updateWaveScrubber(this.wavesurfer, this.scrubber);
    }
    load(url) {
      if (!this.wavesurfer) return Promise.resolve(false);
      if (!url) {
        this.clear();
        return Promise.resolve(false);
      }
      if (url === this.url) {
        this.updateScrubber();
        return Promise.resolve(true);
      }
      const loadId = ++this.loadId;
      this.url = url;
      this.root.classList.remove("has-error");
      this.root.classList.add("is-loading");
      if (this.scrubber) this.scrubber.style.left = "0px";
      return this.wavesurfer.load(url).then(() => {
        if (loadId !== this.loadId) return false;
        this.wavesurfer.setMuted(true);
        this.wavesurfer.pause();
        syncWaveDensity(this.wavesurfer);
        this.root.classList.remove("is-loading");
        this.updateScrubber();
        return true;
      }).catch(() => {
        if (loadId !== this.loadId) return false;
        this.root.classList.remove("is-loading");
        this.root.classList.add("has-error");
        return false;
      });
    }
    // keep progress bars aligned with the playing video
    sync(video) {
      if (!this.wavesurfer || !video) return;
      const duration = this.wavesurfer.getDuration();
      if (!duration) {
        this.updateScrubber();
        return;
      }
      const time = Math.min(
        Math.max(0, video.currentTime || 0),
        duration
      );
      const current = this.wavesurfer.getCurrentTime();
      if (Math.abs(current - time) > 0.05) {
        this.wavesurfer.setTime(time);
      }
      this.updateScrubber();
    }
    clear() {
      if (!this.wavesurfer) return;
      this.loadId += 1;
      this.url = "";
      this.root.classList.remove("is-loading", "has-error");
      this.wavesurfer.empty();
      if (this.scrubber) this.scrubber.style.left = "0px";
    }
    destroy() {
      this.loadId += 1;
      this.wavesurfer?.destroy();
      this.wavesurfer = null;
      this.url = "";
      this.root.classList.remove("is-loading", "has-error");
      delete this.root.videoWave;
    }
  };
  function initAudioPlayers(scope = document) {
    scope.querySelectorAll("[data-audio-player]").forEach((root) => {
      if (root.audioPlayer) return;
      const player = new ProductAudioPlayer(root);
      if (player.wavesurfer) {
        root.audioPlayer = player;
      }
    });
  }
  function pauseAudioPlayersIn(scope) {
    scope.querySelectorAll("[data-audio-player]").forEach((root) => {
      root.audioPlayer?.pause();
    });
  }
  function ensureVideoWave(root) {
    if (!root) return null;
    if (root.videoWave?.wavesurfer) return root.videoWave;
    const wave = new VideoWaveform(root);
    if (!wave.wavesurfer) return null;
    root.videoWave = wave;
    return wave;
  }
  function syncVideoWaves(roots, video) {
    const url = getMediaUrl(video);
    const list = [...roots || []];
    list.forEach((root) => {
      const wave = ensureVideoWave(root);
      if (!wave) return;
      if (!video || !url) {
        wave.clear();
        return;
      }
      wave.load(url).then((ok) => {
        if (ok) wave.sync(video);
      });
    });
  }
  function tickVideoWaves(roots, video) {
    const url = getMediaUrl(video);
    [...roots || []].forEach((root) => {
      const wave = root.videoWave || ensureVideoWave(root);
      if (!wave) return;
      if (!video || !url) {
        if (wave.url) wave.clear();
        return;
      }
      if (wave.url !== url) {
        wave.load(url).then((ok) => {
          if (ok) wave.sync(video);
        });
        return;
      }
      wave.sync(video);
    });
  }
  function destroyVideoWaves(roots) {
    [...roots || []].forEach((root) => {
      root.videoWave?.destroy();
    });
  }
  var initAudioPlayersWhenReady = (scope = document) => {
    initAudioPlayers(scope);
  };
  var runWhenReady = (callback) => {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }
    callback();
  };
  runWhenReady(() => initAudioPlayersWhenReady());
  document.addEventListener("shopify:section:load", (event) => {
    initAudioPlayersWhenReady(event.target);
  });
  return __toCommonJS(audio_player_exports);
})();
